import {
  bumpDocumentsTree,
  requestDocumentReveal,
  useDocumentsUiStore,
} from '../../extensions/bundled/documents/documentsUiStore';
import { docWorkspaceKey } from '../../store/docWorkspaceKey';
import { useDocsLayoutStore } from './docsLayoutStore';

/**
 * The sidebar section id of a document scope (`personal` | `personal/<scopeId>`
 * | `device` | `team:<id>`) — the scope switcher's key for that tree. With the
 * `documents.scopes` flag off every personal document is in the one Personal
 * tree, whatever workspace another device gave it.
 */
export const sectionIdOf = (scope) => docWorkspaceKey(scope);

/**
 * Shows `nodeId` in the Documents sidebar (breadcrumb links, card 2.1):
 * switches the sidebar to the node's tree (card 5.3 — the sidebar shows one
 * tree at a time, and a workspace document is not in Personal's), expands
 * `expandIds` (its ancestors, plus the node itself for a folder) via the
 * sidebar's one-shot reveal request, then scrolls the row into view. In a
 * narrow window the sidebar is an overlay (card 2.6) — it opens first.
 */
export function revealInSidebar(scope, nodeId, expandIds = []) {
  useDocsLayoutStore.getState().setOverlayOpen(true);
  const sectionId = sectionIdOf(scope);
  // `getState?.` — a few component tests stub the store as a bare hook.
  const ui = useDocumentsUiStore.getState?.();
  if (ui && ui.scopeKey !== sectionId) ui.setScopeKey(sectionId);
  if (nodeId != null) {
    requestDocumentReveal(sectionId, nodeId, expandIds);
    // The sidebar applies a reveal after its next reload — this bump is it.
    bumpDocumentsTree();
  }
  setTimeout(() => {
    const sidebar = document.querySelector('.doc-sidebar');
    if (!sidebar) return;
    const row = nodeId != null ? sidebar.querySelector(`[data-drag-id$="-${CSS.escape(String(nodeId))}"]`) : null;
    if (row) row.scrollIntoView({ block: 'nearest' });
    else if (nodeId == null) sidebar.querySelector('.doc-tree-row')?.scrollIntoView({ block: 'nearest' });
  }, 120);
}
